import './CustomZoomControl.scss';
import React, { memo, useEffect } from 'react';
// Hooks
import { Icons, Button } from 'plume-ui';
import { AdjustableComponent } from 'plume-ui/dist/hooks/useClasses';
import { useMap } from 'react-leaflet';
import { LatLngExpression } from 'leaflet';

export type CustomZoomControlProps = {};

type CustomZoomControlStyles = {};

const CustomZoomControl: AdjustableComponent<
  CustomZoomControlProps,
  CustomZoomControlStyles
> = () => {
  const map = useMap();
  let initialPosition: LatLngExpression;
  let initialZoom: number;

  useEffect(() => {
    initialPosition = map.getCenter();
    initialZoom = map.getZoom();
  });

  return (
    <div className="CustomZoomControl">
      <Button styleVariant="tertiary-grey">
        <Icons.HouseIcon
          width={24}
          onClick={() => {
            map.setView(initialPosition, initialZoom);
          }}
        />
      </Button>
      <Button styleVariant="tertiary-grey" onClick={() => map.zoomIn()}>
        <Icons.AddIcon width={24} />
      </Button>
      <Button styleVariant="tertiary-grey" onClick={() => map.zoomOut()}>
        -
      </Button>
    </div>
  );
};

export default memo(CustomZoomControl);
